<template>
  <div class="gwh_video inner">
    <!-- 视频列表页 -->
    <!-- <div class="title">衡水高新区新闻</div> -->
    <div class="mbnav">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <img class="homeIcon" src="/statics/image/index/home.png" alt />
          首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>视频列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="videoList">
      <div
        class="videoItem"
        v-for="(item,index) in videolist"
        :key="index"
        @click="toPlay(item.video_id)"
      >
        <div class="pic">
          <img :src="adddom(item.thumb_image)" alt />
          <span class="time">{{item.video_length}}</span>
        </div>
        <div class="desc">
          <div class="name">
            <span>{{item.title}}</span>
          </div>
          <div class="bot">
            <div class="kan">
              <img src="/statics/image/index/see.png" alt />
              <span>{{item.count}}</span>
            </div>
            <!-- <div class="yan">
              <img src="/statics/image/index/mes.png" alt />
              <span>0</span>
            </div>-->
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="fenye clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pages.size"
          layout="prev, pager, next, jumper"
          :total="newsTotal"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1, //当前页数
      pages: {
        page: 1,
        size: 20
      },
      newsTotal: 0, //总条数
      cateId: "",
      videolist: []
    };
  },
  created() {
    this.cateId = this.$route.query.cate_id;
    this.getVideo();
    function mobileskip() {
      var mobileAgent = new Array(
        "iphone",
        "ipod",
        "ipad",
        "android",
        "mobile",
        "blackberry",
        "webos",
        "incognito",
        "webmate",
        "bada",
        "nokia",
        "lg",
        "ucweb",
        "skyfire"
      );
      var browser = navigator.userAgent.toLowerCase();
      var isMobile = false; //记录是否移动端
      for (var i = 0; i < mobileAgent.length; i++) {
        if (browser.indexOf(mobileAgent[i]) != -1) {
          isMobile = true;
          break;
        }
      }
      return isMobile;
    }
    if (mobileskip()) {
      // console.log("222");
      // 移动端
      this.$router.push({
        path: "/videoPhone",
        query: {
          cate_id: this.cateId
        }
      });
    }
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      this.pages.page = val;
      this.getVideo();
      $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
    },
    toPlay(id) {
      this.$router.push({
        path: "/videoPlay",
        query: {
          id: id
        }
      });
    },
    getVideo() {
      var that = this;
      var ps = {
        cate_id: that.cateId,
        page: that.pages.page,
        size: that.pages.size
      };
      that.$api.index.videolist(ps).then(function(res) {
        if (res.code == 200) {
          that.videolist = res.result.list;
          that.newsTotal = res.result.total;
        }
      });
    }
  }
};
</script>

<style>
</style>